import { Component, OnInit, ViewChild, TemplateRef, ApplicationInitStatus } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelperService } from '../../services/helper.service';
import { QuoteService } from '../../services/quote.service'
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FileService } from '../../services/file.service';
import { QuoteApplicationStatus } from '../../core/constants/status.constants'
import * as moment from 'moment';
import { AgGridAngular, AgGridColumn } from 'ag-grid-angular-legacy';
import { forkJoin } from 'rxjs';
import { GridApi } from 'ag-grid-community';

@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.css']
})
export class QuoteComponent {
  @ViewChild("quote", { static: false }) modalContent: TemplateRef<any>;
  @ViewChild('creditsGrid', { static: false }) creditsGrid: AgGridAngular;
  @ViewChild('paymentsGrid', { static: false }) paymentsGrid: AgGridAngular;
  public creditsGridColumns: AgGridColumn[] | any[] = [];
  public oldPaymentsGridColumns: AgGridColumn[] | any[] = [];
  public newPaymentsGridColumns: AgGridColumn[] | any[] = [];
  public paymentsGridColumns: AgGridColumn[] | any[] = [];
  public paymentsPinnedBottomRows: any[] = [];
  public paymentGridApi: GridApi;

    public isRFQAfterAmendment = false;
  public defaultColDef: { flex: number; resizable: boolean; floatingFilter: boolean; wrapHeaderText: boolean, autoHeaderHeight: boolean };

  title: string = "Quote";
  application: any = {};
  quoteCredits: any[] = [];
  modalReference: any;
  gridApi: any;
  isExpired:boolean = false;
  draftPayment:string = "";

  gstAmount: number = 0;
  totalPaymentExcludingGST: number = 0;
  totalPaymentIncludingGST: number = 0;
  deliveryFeePerCredit: number = 0;
  externalFeePerCredit: number = 0;
  bcfPaymentFee: number = 0;


  constructor(private quoteService: QuoteService, private modalService: NgbModal,
    private helperService: HelperService, private router: Router, private fileService: FileService) { }

   quoteCreditColumnDefs: any = [
    {
      headerName: 'Subregion', field: 'credit.ibraSubregion', sortable: true, filter: 'agTextColumnFilter', minWidth: 175
    },
    {
      headerName: 'Credit category', field: 'credit.creditCategory', sortable: true, filter: 'agTextColumnFilter', minWidth: 125
    },
    {
      headerName: 'Credit type ID', field: 'credit.creditTypeId', sortable: true, filter: 'agTextColumnFilter', minWidth: 125
    },
    {
      headerName: 'Offset trading group', field: 'credit.offsetTradingGroup', sortable: true, filter: 'agTextColumnFilter', minWidth: 250
    },
    {
      headerName: 'HBT status', field: 'credit.hbt', sortable: true, filter: 'agTextColumnFilter', minWidth: 100
    },
    {
      headerName: 'Commonwealth offset (Yes / No)', field: 'commonwealthOffset', sortable: true, filter: 'agTextColumnFilter', minWidth: 175
    },
    {
      headerName: 'No. of BAM Credits', field: 'credit.totalCredits', sortable: true, filter: 'agTextColumnFilter', minWidth: 150, type: 'rightAligned'
    },
    {
      headerName: 'Predicted price per credit (Exc.GST)', valueGetter: params => this.helperService.formatCurrency(params.data.price != null ? params.data.price.predictedPrice : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 175, type: 'rightAligned'
    },
    {
      headerName: 'Risk premium per credit (Exc.GST)', valueGetter: params => this.helperService.formatCurrency(params.data.price != null ? params.data.price.riskPremium : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 175, type: 'rightAligned'
    },
    {
      headerName: 'Delivery fee per credit (Exc.GST)', valueGetter: params => this.helperService.formatCurrency(params.data.price != null ? params.data.price.deliveryFee : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 150, type: 'rightAligned'
    },
    {
      headerName: 'Monthly Indexation per Credit(Exc.GST) ', valueGetter: params => this.helperService.formatCurrency(params.data.monthlyIndexationPerCredit != null ? params.data.monthlyIndexationPerCredit : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 200, type: 'rightAligned'
    },
    {
      headerName: 'No. of months lapsed', field: 'monthsLapsed', sortable: true, filter: 'agTextColumnFilter', minWidth: 175
    },
    {
      headerName: 'Obligation payment per credit (Exc. GST)', valueGetter: params => this.helperService.formatCurrency(params.data.price != null ? params.data.price.paymentPerCredit : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 225
    },
    {
      headerName: 'Total obligation payment (Exc.GST)', valueGetter: params => this.helperService.formatCurrency(params.data.price != null ? params.data.price.totalPrice : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 200, type: 'rightAligned'
    },
    {
      headerName: 'Quote expiry date', valueGetter: params => this.helperService.dateFormat(params.data.expiryDate, "DD/MM/YYYY"), sortable: true, filter: 'agTextColumnFilter', minWidth: 150
    },
    {
      headerName: 'Calculation method', field: 'price.calculationMethod', sortable: true, filter: 'agTextColumnFilter', maxWidth: 175, minWidth: 150
    },

  ];

  private initializeGridColumns(): void {
    this.defaultColDef = {
      flex: 1,
      resizable: true,
      floatingFilter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
    };

    this.creditsGridColumns = [
      {
        headerName: 'Obligation No', field: 'referenceNumber', sortable: true, filter: 'agTextColumnFilter', minWidth: 200
      },
      {
        headerName: 'IBRA subregion', field: 'ibraSubregion', sortable: true, filter: 'agTextColumnFilter', minWidth: 200
      },
      {
        headerName: 'Credit category', field: 'creditCategory', sortable: true, filter: 'agTextColumnFilter', minWidth: 150, maxWidth: 130
      },
      {
        headerName: 'Credit type ID', field: 'creditTypeId', sortable: true, filter: 'agTextColumnFilter', minWidth: 130,
      },
      {
        headerName: 'Offset trading group', field: 'offsetTradingGroup', sortable: true, filter: 'agTextColumnFilter', minWidth: 250
      },
      {
        headerName: 'HBT status', field: 'hbt', sortable: true, filter: 'agTextColumnFilter', minWidth: 100
      },      
      {
        headerName: 'No. of BAM credits', field: 'totalCredits', sortable: true, filter: 'agTextColumnFilter',
        minWidth: 100, type: 'rightAligned'
      }
    ];

    this.oldPaymentsGridColumns = [
      {
        headerName: 'Obligation No', field: 'referenceNumber', sortable: true, filter: 'agTextColumnFilter', minWidth: 200
      },
      {
        headerName: 'No. of BAM credits', field: 'totalCredits', sortable: true, filter: 'agTextColumnFilter',
        minWidth: 100, type: 'rightAligned',
        colSpan: (params: any) => {
          if (!params.node.rowPinned) {
            return 1;
          }

          const displayedColumns = params.columnApi.getAllDisplayedColumns();
          const totalCreditsColumnIndex = displayedColumns.findIndex((column: any) => column.getColDef().field === 'totalCredits');
          const totalPaymentColumnIndex = displayedColumns.findIndex((column: any) => column.getColDef().field === 'totalPayment');
          return (totalPaymentColumnIndex > 0 && totalCreditsColumnIndex >= 0) ? totalPaymentColumnIndex - totalCreditsColumnIndex : 1;
        }
      },
      {
        headerName: 'Predicted price per credit(Exc. GST)', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => this.helperService.formatCurrency(params.data.predictedPrice),
        type: 'rightAligned'
      },
      {
        headerName: 'Risk premium per credit(Exc. GST)', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => this.helperService.formatCurrency(params.data.riskPremium),
        type: 'rightAligned'
      },
      {
        headerName: 'Delivery fee per credit(Exc. GST)', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => this.helperService.formatCurrency(params.data.deliveryFee),
        type: 'rightAligned'
      },
      {
        headerName: 'Monthly Indexation per credit(Exc. GST)', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => this.helperService.formatMonthlyIndexation(params.data.monthlyIndexation),
        type: 'rightAligned'
      },
      {
        headerName: 'No. of months lapsed ', field: 'monthsLapsed', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        type: 'rightAligned'
      },
      {
        headerName: 'Obligation payment per credit', field:'paymentPerCredit', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => this.helperService.formatCurrency(params.data.paymentPerCredit),
        type: 'rightAligned'
      },
      {
        headerName: 'Total obligation payment', field: 'totalPayment', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: (params) => {
          return this.helperService.formatCurrency(params.data.totalPayment)
        },
        type: 'rightAligned'
      }
    ];

    this.newPaymentsGridColumns = [
      {
        headerName: 'Obligation No', field: 'referenceNumber', sortable: true, filter: 'agTextColumnFilter', minWidth: 200
      },
      {
        headerName: 'No. of BAM credits', field: 'totalCredits', sortable: true, filter: 'agTextColumnFilter',
        minWidth: 100, type: 'rightAligned',
        colSpan: (params: any) => {
          if (!params.node.rowPinned) {
            return 1;
          }

          const displayedColumns = params.columnApi.getAllDisplayedColumns();
          const totalCreditsColumnIndex = displayedColumns.findIndex((column: any) => column.getColDef().field === 'totalCredits');
          const totalPaymentColumnIndex = displayedColumns.findIndex((column: any) => column.getColDef().field === 'totalpredictedPrice');
          return (totalPaymentColumnIndex > 0 && totalCreditsColumnIndex >= 0) ? totalPaymentColumnIndex - totalCreditsColumnIndex : 1;
        }
      },
      {
        headerName: 'Predicted price per credit(Exc. GST)', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => params.node.rowPinned ? '-' : this.helperService.formatCurrency(params.data.predictedPrice),
        type: 'rightAligned'
      },
      {
        headerName: 'Risk premium per credit(Exc. GST)', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => params.node.rowPinned ? '-' : this.helperService.formatCurrency(params.data.riskPremium),
        type: 'rightAligned'
      },
      {
        headerName: 'Delivery fee per credit(Exc. GST)', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => params.node.rowPinned ? '-' : this.helperService.formatCurrency(params.data.deliveryFee),
        type: 'rightAligned'
      },
      {
        headerName: 'External fee per credit(Exc. GST)', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => params.node.rowPinned ? '-' : this.helperService.formatCurrency(params.data.externalFeePerCredit),
        type: 'rightAligned'
      },
      {
        headerName: 'Obligation payment excluding fees(GST payable)', field:'totalpredictedPrice', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => params.data.totalpredictedPrice ? this.helperService.formatCurrency(params.data.totalpredictedPrice) : '-',
        type: 'rightAligned'
      },
      {
        headerName: 'Delivery costs - Per credit and fixed fee(GST payable)', field:'totalDeliveryFee', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => params.data.totalDeliveryFee ? this.helperService.formatCurrency(params.data.totalDeliveryFee) : '-',
        type: 'rightAligned'
      },
      {
        headerName: 'Delivery costs - External fee (Non-GST)', field:'totalExternalFee', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => params.data.totalExternalFee ? this.helperService.formatCurrency(params.data.totalExternalFee) : '-',
        type: 'rightAligned'
      },
      {
        headerName: 'Total obligation payment', field: 'totalPayment', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: params => params.data.totalPayment ? this.helperService.formatCurrency(params.data.totalPayment) : '-',
        type: 'rightAligned'
      }
    ];

    this.paymentsGridColumns = this.oldPaymentsGridColumns;
  }
  
  ngOnInit() {
    this.initializeGridColumns();

    this.quoteService.getQuoteRegisterSettings().subscribe(settings => {
      const find = (code: string) => settings.find((s: any) => s.code === code);
      this.bcfPaymentFee = find('QTEBCFFEE')?.decimalValue ?? 0;
    });

  }

  onPaymentsGridReady(params: any) {
    this.paymentGridApi = params.api;
    //this.paymentGridApi.sizeColumnsToFit();
    if (this.isRFQAfterAmendment) {
      setTimeout(() => this.setNewColTotalRow(), 0);
    } else {
      this.updatePaymentsPinnedBottomRows();
    }
  }

  private updatePaymentsPinnedBottomRows(): void {
    this.paymentsPinnedBottomRows = [
      {
        totalCredits: 'Total (Exc. GST)',
        totalPayment: this.totalPaymentExcludingGST || 0,
      },
      {
        totalCredits: 'GST',
        totalPayment: this.gstAmount || 0,
      },
      {
        totalCredits: 'Total (Inc. GST)',
        totalPayment: this.totalPaymentIncludingGST || 0,
      },
    ];
  }

  public getPaymentsRowStyle = (params: any) => {
    return params.node && params.node.rowPinned ? { fontWeight: '700' } : null;
  }

  get status(): string {
    if (this.application.status == QuoteApplicationStatus.Issued) return "Quote Issued";
    else if (this.application.status == QuoteApplicationStatus.InProgress) return "In Progress";
    else if (this.application.status == QuoteApplicationStatus.Cancelled) return "Quote application cancelled";
    else if (this.application.status == QuoteApplicationStatus.Accepted) return "Quote accepted";
    else if (this.application.status == QuoteApplicationStatus.PartiallyAccepted) return "Quote partially accepted";
    else return this.application.status
  }

  get category(): string {
    if (this.application.category == "SP") return "Small Project";
    else if (this.application.category == "LP") return "Large Project";
    else return this.application.category
  }

  get issueDate(): string {
    
    if ((this.application.status == QuoteApplicationStatus.Issued || 
         this.application.status == QuoteApplicationStatus.Accepted || 
         this.application.status == QuoteApplicationStatus.PartiallyAccepted)
       && this.application.issuedDate) {
      return this.helperService.dateFormat(this.application.issuedDate, "DD/MM/YYYY");
    }
    return "";
  }

  get allowSubmit(): boolean {
    if (this.application == null) return false;
    const status = this.application.status;
    if (status == null || status == undefined) return false;
    if (this.draftPayment != '' || this.isExpired) return false;
    
    return status === QuoteApplicationStatus.Issued
      || status === QuoteApplicationStatus.Accepted
      || status === QuoteApplicationStatus.PartiallyAccepted  ? true : false;
  }

  get showViewQuote(): boolean {
    if (this.application == null || !this.application.status) return false;
    return this.application.status !== QuoteApplicationStatus.Draft && this.application.status !== QuoteApplicationStatus.InProgress;
  }


  get popupTitle(): string {
    if (this.application && this.application.referenceNumber) {
      
      this.title = 'Quote' ;

      if(this.application.status === QuoteApplicationStatus.InProgress)
        this.title = 'Request for Quote' ;
      
      if(this.application.status === QuoteApplicationStatus.Cancelled)
        this.title += ' Cancelled'

      if(this.application.status === QuoteApplicationStatus.Issued)
        this.title += ' Issued'

      return `${this.title} - ${this.application.referenceNumber}`;
    }
    return this.title;
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  open(id: number) {
    this.draftPayment= '';
    this.isExpired = false;
    this.gstAmount = 0;
    this.totalPaymentExcludingGST = 0;
    this.totalPaymentIncludingGST = 0;
    this.updatePaymentsPinnedBottomRows();

    forkJoin({
      statement: this.quoteService.getQuoteStatement(id),
      application: this.quoteService.get(id)
    }).subscribe(({ statement, application }) => {

      this.application = application;
      this.isRFQAfterAmendment = !!this.application.isRFQAfterAmendment;
      this.paymentsGridColumns = this.isRFQAfterAmendment ? this.newPaymentsGridColumns : this.oldPaymentsGridColumns;
      this.quoteCredits = statement.credits ?? [];
      this.setPriceValues();

      this.gstAmount = statement.gstAmount;
      this.totalPaymentExcludingGST = statement.totalPaymentExcludingGST;
      this.totalPaymentIncludingGST = statement.totalPaymentIncludingGST;
      //this.updatePaymentsPinnedBottomRows();

      if(application.obligationPayments) {
          //get the first payment and get the external fee per credit 
          const firstPayment = application.obligationPayments[0];
          if (firstPayment) {
            this.bcfPaymentFee = firstPayment.bcfPaymentFee ?? 0;
          }
      }

      this.checkExpiry();
      if (!this.isExpired) {
        const matchingPayment = application.obligationPayments.find((payment: any) =>
          payment.status === 'DFT'
        );
        if (matchingPayment && matchingPayment.bcfReferenceNumber !== '') {
          this.draftPayment = matchingPayment.bcfReferenceNumber;
        }
      }

      this.modalReference = this.modalService.open(this.modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'xl', backdrop: 'static' });
    });

  }

  setPriceValues() {
    this.quoteCredits = this.quoteCredits.map((credit: any) => {
      const res: any = {};
      res.referenceNumber = credit.referenceNumber;
      res.credit = {};
      res.credit.ibraSubregion = credit.credit?.ibraSubregion;
      res.credit.creditCategory = credit.credit?.creditCategory;
      res.credit.creditTypeId = credit.credit?.creditTypeId;
      res.credit.offsetTradingGroup = credit.credit?.offsetTradingGroup;
      res.credit.hbt = credit.credit?.hbt ? 'Yes' : 'No';
      res.credit.totalCredits = credit.credit?.totalCredits ?? 0;
      res.credit.commonwealthOffset = credit.commonwealthOffset;
      res.monthlyIndexation = credit.monthlyIndexation ?? 0;
      res.monthlyIndexationPerCredit = credit.monthlyIndexation ?? 0;
      res.monthsLapsed = credit.monthsLapsed;
      res.expiryDate = credit.expiryDate;

      const totalCredits = res.totalCredits;
      const price = credit.price || {};
      res.price = {};
      res.price.predictedPrice = price.predictedPrice ?? 0;
      res.price.riskPremium = price.riskPremium ?? 0;
      res.price.deliveryFee = price.deliveryFee ?? 0;
      res.price.calculationMethod = price.calculationMethod ?? 0;
      res.price.obligationPaymentPerCredit = price.obligationPaymentPerCredit ?? 0;
      res.paymentPerCredit = price.paymentPerCredit ?? 0;

      if (this.isRFQAfterAmendment) {
        const externalFeePerCredit = price.externalFeePerCredit != null ? price.externalFeePerCredit : this.externalFeePerCredit;
        const deliveryFeePerCredit = price.deliveryFee != null ? price.deliveryFee : this.deliveryFeePerCredit;
        
        res.price.externalFeePerCredit = externalFeePerCredit;
        res.price.deliveryFee = deliveryFeePerCredit;
        res.price.totalpredictedPrice = totalCredits * (res.price.predictedPrice+res.price.riskPremium);
        res.price.totalRiskPremium = totalCredits * res.price.riskPremium;
        res.price.totalPriceExclFee = res.price.totalpredictedPrice + res.price.totalRiskPremium;
        res.price.totalExternalFee = totalCredits * externalFeePerCredit;
        res.price.totalDeliveryFee = totalCredits * deliveryFeePerCredit;
        res.price.totalPayment = res.price.totalpredictedPrice + res.price.totalExternalFee + res.price.totalDeliveryFee;
        res.bcfPaymentFee = this.bcfPaymentFee;
      } else {
        res.price.totalpredictedPrice = totalCredits * res.price.predictedPrice;
        res.price.totalRiskPremium = totalCredits * res.price.riskPremium;
        res.price.totalIndexation = totalCredits * (credit.monthlyIndexationPerCredit != null && res.monthsLapsed != null ? credit.monthlyIndexationPerCredit * res.monthsLapsed : 0);
        res.price.totalDeliveryFee = totalCredits * res.price.deliveryFee;
        res.price.totalPriceExclFee = res.price.totalpredictedPrice + res.price.totalRiskPremium + res.price.totalIndexation;
        res.price.totalPayment = res.price.totalPriceExclFee + res.price.totalDeliveryFee;
      }

      return res;
    });
  }

  
  private setNewColTotalRow = () => {
    //set the total row
    var result: any[] = [];

    // Total for price.totalPrice
    var totalDeliveryFeeExclGst: number = 0;
    var totalPaymentExclFee: number = 0;
    var externalFeeTotal: number = 0;
    // Do not apply fixed fee when there are no credits; last-row delete should reset totals to zero.
    var fixedExternalFee: number = this.quoteCredits && this.quoteCredits.length > 0 && this.bcfPaymentFee != null ? this.bcfPaymentFee : 2460;

    this.quoteCredits.map((credit: any, index: any) => {
      totalPaymentExclFee += credit.price.totalpredictedPrice || 0;
      totalDeliveryFeeExclGst += credit.price.totalDeliveryFee || 0;
      externalFeeTotal += credit.price.totalExternalFee || 0;
    });

    var totalwithoutgst: number = totalPaymentExclFee + totalDeliveryFeeExclGst + externalFeeTotal;

    var totalExternalFeeGst: number = 0;
    var totalExternalFeeInclGst: number = externalFeeTotal + totalExternalFeeGst;

    var totalPaymentExclFeeGst: number = (totalPaymentExclFee ) * 0.10;
    var totalPaymentExclFeeInclGst: number = totalPaymentExclFee + totalPaymentExclFeeGst;

    var totalDeliveryFeeGst: number = (totalDeliveryFeeExclGst + fixedExternalFee) * 0.10;
    var totalDeliveryFeeInclGst: number = totalDeliveryFeeExclGst + totalDeliveryFeeGst;

   

    // First pinned row: fixed fee (non-GST) shown in delivery costs and total obligation columns.
    const fixedFeeRow = {
      totalCredits: 'Delivery cost - Fixed fee',
      totalpredictedPrice: 0,
      totalDeliveryFee: fixedExternalFee,
      totalExternalFee: 0,
      totalPayment: fixedExternalFee
    };

    // Totals for price.totalPrice
    const totalWithoutGST = {
      totalCredits: 'Total (Exc. GST)',
      totalpredictedPrice: totalPaymentExclFee,
      totalDeliveryFee: totalDeliveryFeeExclGst + fixedExternalFee,
      totalExternalFee: externalFeeTotal,
      totalPayment: totalPaymentExclFee + totalDeliveryFeeExclGst + externalFeeTotal + fixedExternalFee
    };
    const totalGST = {
      totalCredits: 'GST',
      totalpredictedPrice: totalPaymentExclFeeGst,
      totalDeliveryFee: totalDeliveryFeeGst,
      totalExternalFee: totalExternalFeeGst,
      totalPayment: totalPaymentExclFeeGst + totalExternalFeeGst + totalDeliveryFeeGst
    };
    const totalWithGST = {
      totalCredits: 'Total (Inc. GST)',
      totalpredictedPrice: totalPaymentExclFeeInclGst,
      totalDeliveryFee: totalDeliveryFeeInclGst + fixedExternalFee,
      totalExternalFee: totalExternalFeeInclGst,
      totalPayment: totalPaymentExclFeeInclGst + totalDeliveryFeeInclGst + fixedExternalFee + totalExternalFeeInclGst
    };

    result.push(fixedFeeRow);
    result.push(totalWithoutGST);
    result.push(totalGST);
    result.push(totalWithGST);

    if (this.paymentGridApi) {
      this.paymentGridApi.setPinnedBottomRowData(result);
    }
  }

  downloadQuote() {
    const id = this.application.id;
    this.fileService.downloadQuote(id, this.application.referenceNumber);
  }

  downloadRFQ() {
    const id = this.application.id;
    this.fileService.downloadRFQ(id, this.application.referenceNumber);
  }

  close() {
    this.modalReference.close();
  }

  submitRTMP() {
    this.modalReference.close();
    this.router.navigate(['quotes/rtmp/' + this.application.id])
  }

   public checkExpiry() {

    this.isExpired = false;

    if (!this.application) 
      return;

    let expiry = this.application.expiryDate ? this.application.expiryDate : "";
    let adjustedexpiry = this.application.adjustedExpiryDate ? this.application.adjustedExpiryDate : "";

    if (adjustedexpiry != "")
      expiry = adjustedexpiry;

    if (moment(expiry).isValid()) {

      if (moment(expiry).isAfter(moment()))
        this.isExpired = false;
      else {
        this.isExpired = true;
        //this.helperService.toasterService.error("This quote has been expired.");
      }
    }

  }
}
